export default __webpack_public_path__ + "static/casestudybg-c8b6128f4fb9b3a62417cbe435adc3d1.png";